
// Импорт только базовых переменных
import "./assets/style/vars.css";

// Buttons
export { default as ButtonAccentPrimary } from "./components/Buttons/Default/ButtonAccentPrimary.vue";
export { default as ButtonAccentSecondary } from "./components/Buttons/Default/ButtonAccentSecondary.vue";
export { default as ButtonAccentTertiary } from "./components/Buttons/Default/ButtonAccentTertiary.vue";
export { default as ButtonNeutralPrimary } from "./components/Buttons/Default/ButtonNeutralPrimary.vue";
export { default as ButtonNeutralSecondary } from "./components/Buttons/Default/ButtonNeutralSecondary.vue";
export { default as ButtonNeutralTertiary } from "./components/Buttons/Default/ButtonNeutralTertiary.vue";

// Fixed Buttons
export { default as ButtonFixedDark } from "./components/Buttons/Fixed/ButtonFixedDark.vue";
export { default as ButtonFixedPrimary } from "./components/Buttons/Fixed/ButtonFixedPrimary.vue";
export { default as ButtonFixedSecondary } from "./components/Buttons/Fixed/ButtonFixedSecondary.vue";
export { default as ButtonFixedTertiary } from "./components/Buttons/Fixed/ButtonFixedTertiary.vue";

// Icon Buttons
export { default as ButtonIconAccentPrimary } from "./components/Buttons/Icon/ButtonIconAccentPrimary.vue";
export { default as ButtonIconAccentSecondary } from "./components/Buttons/Icon/ButtonIconAccentSecondary.vue";
export { default as ButtonIconNeutralPrimary } from "./components/Buttons/Icon/ButtonIconNeutralPrimary.vue";
export { default as ButtonIconNeutralSecondary } from "./components/Buttons/Icon/ButtonIconNeutralSecondary.vue";

// Rounded Buttons
export { default as ButtonRoundedGhost } from "./components/Buttons/Rounded/ButtonRoundedGhost.vue";
export { default as ButtonRoundedPrimary } from "./components/Buttons/Rounded/ButtonRoundedPrimary.vue";
export { default as ButtonRoundedSecondary } from "./components/Buttons/Rounded/ButtonRoundedSecondary.vue";
export { default as ButtonRoundedTertiary } from "./components/Buttons/Rounded/ButtonRoundedTertiary.vue";

// Card
export { default as Card } from "./components/Card/Card.vue";

// Checkbox
export { default as Checkbox } from "./components/Checkbox/Checkbox.vue";
export { default as RadioButton } from "./components/Checkbox/RadioButton.vue";

// Chips
export { default as Chip } from "./components/Chips/Chip.vue";
export { default as Sentiment } from "./components/Chips/Sentiment.vue";

// DatePicker
export { default as DateControl } from "./components/DatePicker/DateControl.vue";
export { default as DateGrid } from "./components/DatePicker/DateGrid.vue";
export { default as DatePicker } from "./components/DatePicker/DatePicker.vue";
export { default as DateView } from "./components/DatePicker/DateView.vue";
export { default as GlobusCalendar } from "./components/DatePicker/GlobusCalendar.vue";
export { default as MonthYearSelector } from "./components/DatePicker/MonthYearSelector.vue";

// Dropdown
export { default as SimpleDropdown } from "./components/Dropdown/SimpleDropdown.vue";
export { default as Dropdown } from "./components/Dropdown/Dropdown.vue";
export { default as DropdownItem } from "./components/Dropdown/DropdownItem.vue";

// Form
export { default as InputPhone } from "./components/Form/InputPhone.vue";
export { default as InputPrimary } from "./components/Form/InputPrimary.vue";
export { default as InputSearchPrimary } from "./components/Form/InputSearchPrimary.vue";
export { default as InputSearchSecondary } from "./components/Form/InputSearchSecondary.vue";
export { default as InputSearchTertiary } from "./components/Form/InputSearchTertiary.vue";
export { default as InputSecondary } from "./components/Form/InputSecondary.vue";
export { default as TextAreaPrimary } from "./components/Form/TextAreaPrimary.vue";
export { default as TextAreaSecondary } from "./components/Form/TextAreaSecondary.vue";
export { default as ComboBoxPrimary } from "./components/Form/ComboBoxPrimary.vue";
export { default as ComboBoxSecondary } from "./components/Form/ComboBoxSecondary.vue";

// Code
export { default as CodeView } from "./components/Code/CodeView.vue";

// Modal
export { default as Modal } from "./components/Modal/Modal.vue";
export { default as Sidebar } from "./components/Modal/Sidebar.vue";

// Notification
export { default as NotificationBlock } from "./components/Notification/NotificationBlock.vue";
export { default as NotificationItem } from "./components/Notification/NotificationItem.vue";

// Spinner
export { default as Spinner } from "./components/Spinner/Spinner.vue";

// Tabbar
export { default as TabBar } from "./components/Tabbar/TabBar.vue";
export { default as TabBarItem } from "./components/Tabbar/TabBarItem.vue";

// Icons
export { default as IconArchive } from "./assets/icons/IconArchive.vue";
export { default as IconButton } from "./assets/icons/IconButton.vue";
export { default as IconCalendar } from "./assets/icons/IconCalendar.vue";
export { default as IconCross } from "./assets/icons/IconCross.vue";
export { default as IconForm } from "./assets/icons/IconForm.vue";
export { default as IconGlobus } from "./assets/icons/IconGlobus.vue";
export { default as IconLocation } from "./assets/icons/IconLocation.vue";
export { default as IconSearch } from "./assets/icons/IconSearch.vue";
export { default as IconSentimentGood } from "./assets/icons/IconSentimentGood.vue";
export { default as IconSentimentNeutral } from "./assets/icons/IconSentimentNeutral.vue";
export { default as IconSentimentSad } from "./assets/icons/IconSentimentSad.vue";

// list

export { default as ListView } from "./components/List/ListView.vue";
export { default as ListViewItem } from "./components/List/ListItem.vue";

// Composables
export { default as debouncer } from "./composables/debouncer.js";
export * from "./composables/directives.js";
export { default as tooltip } from "./composables/tooltip.js";

// Import components for install function
import ButtonAccentPrimary from "./components/Buttons/Default/ButtonAccentPrimary.vue";
import ButtonAccentSecondary from "./components/Buttons/Default/ButtonAccentSecondary.vue";
import ButtonAccentTertiary from "./components/Buttons/Default/ButtonAccentTertiary.vue";
import ButtonNeutralPrimary from "./components/Buttons/Default/ButtonNeutralPrimary.vue";
import ButtonNeutralSecondary from "./components/Buttons/Default/ButtonNeutralSecondary.vue";
import ButtonNeutralTertiary from "./components/Buttons/Default/ButtonNeutralTertiary.vue";
import ButtonFixedFilled from "./components/Buttons/Fixed/ButtonFixedFilled.vue";
import ButtonFixedDark from "./components/Buttons/Fixed/ButtonFixedDark.vue";
import ButtonFixedPrimary from "./components/Buttons/Fixed/ButtonFixedPrimary.vue";
import ButtonFixedSecondary from "./components/Buttons/Fixed/ButtonFixedSecondary.vue";
import ButtonFixedTertiary from "./components/Buttons/Fixed/ButtonFixedTertiary.vue";
import ButtonIconAccentPrimary from "./components/Buttons/Icon/ButtonIconAccentPrimary.vue";
import ButtonIconAccentSecondary from "./components/Buttons/Icon/ButtonIconAccentSecondary.vue";
import ButtonIconNeutralPrimary from "./components/Buttons/Icon/ButtonIconNeutralPrimary.vue";
import ButtonIconNeutralSecondary from "./components/Buttons/Icon/ButtonIconNeutralSecondary.vue";
import ButtonRoundedGhost from "./components/Buttons/Rounded/ButtonRoundedGhost.vue";
import ButtonRoundedPrimary from "./components/Buttons/Rounded/ButtonRoundedPrimary.vue";
import ButtonRoundedSecondary from "./components/Buttons/Rounded/ButtonRoundedSecondary.vue";
import ButtonRoundedTertiary from "./components/Buttons/Rounded/ButtonRoundedTertiary.vue";
import Card from "./components/Card/Card.vue";
import Checkbox from "./components/Checkbox/Checkbox.vue";
import RadioButton from "./components/Checkbox/RadioButton.vue";
import Chip from "./components/Chips/Chip.vue";
import Sentiment from "./components/Chips/Sentiment.vue";
import DateControl from "./components/DatePicker/DateControl.vue";
import DateGrid from "./components/DatePicker/DateGrid.vue";
import DatePicker from "./components/DatePicker/DatePicker.vue";
import DateView from "./components/DatePicker/DateView.vue";
import GlobusCalendar from "./components/DatePicker/GlobusCalendar.vue";
import MonthYearSelector from "./components/DatePicker/MonthYearSelector.vue";
import SimpleDropdown from "@/components/Dropdown/SimpleDropdown.vue";
import Dropdown from "./components/Dropdown/Dropdown.vue";
import DropdownItem from "./components/Dropdown/DropdownItem.vue";
import InputPhone from "./components/Form/InputPhone.vue";
import InputPrimary from "./components/Form/InputPrimary.vue";
import TextAreaPrimary from "@/components/Form/TextAreaPrimary.vue";
import TextAreaSecondary from "@/components/Form/TextAreaSecondary.vue";
import InputSearchPrimary from "./components/Form/InputSearchPrimary.vue";
import InputSearchSecondary from "./components/Form/InputSearchSecondary.vue";
import InputSearchTertiary from "@/components/Form/InputSearchTertiary.vue";
import InputSecondary from "./components/Form/InputSecondary.vue";
import ComboBoxPrimary from "@/components/Form/ComboBoxPrimary.vue";
import ComboBoxSecondary from "./components/Form/ComboBoxSecondary.vue";
import CodeView from "./components/Code/CodeView.vue";
import Modal from "./components/Modal/Modal.vue";
import Sidebar from "./components/Modal/Sidebar.vue";
import NotificationBlock from "./components/Notification/NotificationBlock.vue";
import NotificationItem from "./components/Notification/NotificationItem.vue";
import Spinner from "./components/Spinner/Spinner.vue";
import TabBar from "./components/Tabbar/TabBar.vue";
import TabBarItem from "./components/Tabbar/TabBarItem.vue";
import IconArchive from "./assets/icons/IconArchive.vue";
import IconButton from "./assets/icons/IconButton.vue";
import IconCalendar from "./assets/icons/IconCalendar.vue";
import IconCross from "./assets/icons/IconCross.vue";
import IconForm from "./assets/icons/IconForm.vue";
import IconGlobus from "./assets/icons/IconGlobus.vue";
import IconLocation from "./assets/icons/IconLocation.vue";
import IconSearch from "./assets/icons/IconSearch.vue";
import IconSentimentGood from "./assets/icons/IconSentimentGood.vue";
import IconSentimentNeutral from "./assets/icons/IconSentimentNeutral.vue";
import IconSentimentSad from "./assets/icons/IconSentimentSad.vue";

import ListView from "@/components/List/ListView.vue";
import ListItem from "@/components/List/ListItem.vue";

// Install function for Vue.use()
export default function install(app) {
  // Регистрация всех компонентов глобально
  const components = {
    ButtonAccentPrimary,
    ButtonAccentSecondary,
    ButtonAccentTertiary,
    ButtonNeutralPrimary,
    ButtonNeutralSecondary,
    ButtonNeutralTertiary,
    ButtonFixedDark,
    ButtonFixedPrimary,
    ButtonFixedSecondary,
    ButtonFixedTertiary,
    ButtonFixedFilled,
    ButtonIconAccentPrimary,
    ButtonIconAccentSecondary,
    ButtonIconNeutralPrimary,
    ButtonIconNeutralSecondary,
    ButtonRoundedGhost,
    ButtonRoundedPrimary,
    ButtonRoundedSecondary,
    ButtonRoundedTertiary,
    Card,
    Checkbox,
    RadioButton,
    Chip,
    Sentiment,
    DateControl,
    DateGrid,
    DatePicker,
    DateView,
    GlobusCalendar,
    MonthYearSelector,
    SimpleDropdown,
    Dropdown,
    DropdownItem,
    InputPhone,
    InputPrimary,
    InputSearchPrimary,
    InputSearchSecondary,
    InputSearchTertiary,
    InputSecondary,
    ComboBoxPrimary,
    ComboBoxSecondary,
    TextAreaPrimary,
    TextAreaSecondary,
    CodeView,
    Modal,
    Sidebar,
    NotificationBlock,
    NotificationItem,
    Spinner,
    TabBar,
    TabBarItem,
    IconArchive,
    IconButton,
    IconCalendar,
    IconCross,
    IconForm,
    IconGlobus,
    IconLocation,
    IconSearch,
    IconSentimentGood,
    IconSentimentNeutral,
    IconSentimentSad,
    ListView,
    ListItem
  };

  Object.keys(components).forEach(name => {
    app.component(name, components[name]);
  });
}